import React from 'react';
import FullCard from '../../../../components/Card/FullCard';
import { Switch, Route, useLocation } from 'react-router-dom';
import useTitle from 'hooks/useTitle';
import FreightsList from './FreightsList';
import FreightOrdersList from './FreightOrdersList';
import { useFreight } from 'useStores/useFreight';
import FreightItems from './FreightItems';
import NewFreightOrder from './NewFreightOrder/NewFreightOrder';
import EditFreightOrder from './EditFreightOrder/EditFreightOrder';

const Freights = (props) => {
  useTitle('باربری ها');
  const title = useFreight((state) => state.title);
  const category = useFreight((state) => state.category);
  const parentUrl = `/protected/admin/freights`;
  const location = useLocation();

  return (
    <FullCard title={title} category={category}>
      {`/protected/admin${props.config.path}` === location.pathname ? (
        <FreightItems />
      ) : (
        <Switch>
          <Route path={`${parentUrl}/freights`}>
            <Freights />
          </Route>
          <Route path={`${parentUrl}/freightsOrders`}>
            <FreightsList />
          </Route>
          <Route path={`${parentUrl}/freightOrders/:freightId`}>
            <FreightOrdersList />
          </Route>
          <Route path={`${parentUrl}/newOrder`}>
            <NewFreightOrder />
          </Route>
          <Route path={`${parentUrl}/editFreightOrder/:orderId`}>
            <EditFreightOrder />
          </Route>
        </Switch>
      )}
    </FullCard>
  );
};

export default Freights;
